import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Chart } from '../../../../helpers/chart.js';
import { fetchJson } from '../../../../helpers';
import { useSelector } from 'react-redux';
import { useChartResize } from '../../hooks/useChartResize.js';
import { DEFAULT_COLORS } from '../base/constants.js';

import {
    monitoring_dashboard_phase_progress_data_path
} from '~/routes';
import LoadingIndicator from '../../../common/loading_indicator';
import NoDataComponent from '../../no_data_component.jsx';

function PhaseProgressWidget({ widgetId }) {
    const phaseStatusChartRef = useRef();
    const [chart, setChart] = useState();
    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState(null);
    const phase_id = useSelector(state => state.dashboard.widgets[widgetId].settings?.phase_id);
    const submit_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.submit_color);
    const draft_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.draft_color);
    const drop_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.drop_color);
    const legend_text_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.legend_text_color);

    const initChart = useCallback(() => {
        if (chart) chart.destroy();
        if (!phaseStatusChartRef.current || !chartData) return;
        const barsDataWithColors = {
            ...chartData,
            datasets: chartData.datasets.map((d, i) => {
            return {
                ...d, 
                backgroundColor: [submit_color, draft_color, drop_color][i] || DEFAULT_COLORS[i]
            }
            })
        }
        setChart(new Chart(phaseStatusChartRef.current, {
      type: "bar",
      data: barsDataWithColors,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        // tooltips: {
        //   enabled: true,
        //   callbacks: {
        //     label: function (tt, data) {
        //       return (tt.yLabel + '');
        //     }
        //   }
        // },
        legend: {
          labels: {
            color: legend_text_color
          }
        },
        scales: {
          x: {
              stacked: true,
              ticks: {
                autoSkip: false,
                minRotation: 90,
              },
            },
          y: {
              stacked: true,
              ticks: {
                callback: function (value, index, values) {
                  return Number.isInteger(value) ? value : "";
                },
                beginAtZero: true,
              },
            },
        },
        tooltips: {
          mode: "index",
        },
      },
    }))
    }, [chartData, submit_color, draft_color, drop_color, legend_text_color])

    const handleResize = useChartResize(phaseStatusChartRef, initChart);

    const loadData = (phaseId) => {
        if (chart) chart.destroy();
        setLoading(true);
        fetchJson(monitoring_dashboard_phase_progress_data_path({ phase_id: phaseId })).then((res) => {
            setLoading(false);
            setChartData(res)
        })
    }

    useEffect(() => {
        return () => {
            if (chart) chart.destroy();
        }
    }, [])

    useEffect(() => {
        if (phase_id){
            loadData(phase_id)
        }
    }, [phase_id])

    useEffect(() => {
        if (!loading && chartData){
            handleResize();
        }
    }, [chartData, submit_color, draft_color, drop_color, legend_text_color])

    return (
      loading ? <LoadingIndicator /> :
      ( phase_id ?
      <div className="chart-container-gen2">
        <canvas ref={phaseStatusChartRef} />
      </div> : <NoDataComponent />)
    )
    
}

export default PhaseProgressWidget;
